export default {
  path: '/reports/parentinventory',
  component: () =>
    import('@/views/general-reports/parent-inventory/Wrapper.vue'),
  children: [
    {
      path: '',
      name: 'parentinventory',
      component: () =>
        import('@/views/general-reports/parent-inventory/Main.vue'),
    },
  ],
}

